import { StepForm } from '@iq-firebolt/client'
import fireboltBlueberry from '@iq-firebolt/blueberry-theme'

import { incomeProofMaximumMonthsOld } from 'constants/incomeProof'

import useStepTemplate from 'hooks/useStepTemplate'
import FormContainer from 'components/common/FormContainer'
import ActionButtons from 'components/common/ActionButtons'

import SplitDateMonth from '../../components/SplitDateMonth'

import { FormTitle } from 'components/common/FormTitle'

const IncomeData = ({ fireboltStep }) => {
  const { handleGoBackform, runBeforeChangeStep } = useStepTemplate({
    fireboltStep,
  })

  return (
    <FormContainer imageSrc="images/bb/ourocard-novo.png">
      <div>
        <FormTitle title="Sobre sua renda" hasRequiredFieldWarning />
        <StepForm
          onSubmit={fireboltStep?.goNextStep}
          theme={{
            ...fireboltBlueberry,
            'CustomSplitDateMonth': (props) => (
              <SplitDateMonth
                {...props}
                fireboltStep={fireboltStep}
                maximumMonthsOld={incomeProofMaximumMonthsOld}
              />
            ),
          }}
          customActionsChild={({ formData }) => (
            <ActionButtons
              formData={formData}
              onGoBack={handleGoBackform}
              beforeSubmitStep={runBeforeChangeStep}
            />
          )}
        />
      </div>
    </FormContainer>
  )
}

export default IncomeData
